import Logo from 'components/main/Logo'

export default function ChatBotAvatar() {
  return (
      <div className="flex flex-shrink-0 w-[2.375rem] h-[2.375rem] rounded-full bg-blue-600 justify-center items-center">
        <Logo color="white" className="w-[60%] h-auto"/>
      </div>
  )
}